/**
 * 文字の大きさの倍率
 * Tailwindのtext-* / leading-*（tailwind.config.js）とインラインstyle（WebPrimitivesのnormalizeStyle）が、
 * 同じCSS変数の倍率で文字だけを拡大するための共通定義です。
 */

/** 文字の大きさの倍率を受け取るCSS変数。tailwind.config.jsと同じ名前であることを契約テストで確かめる */
export const TEXT_SCALE_CSS_VARIABLE = '--app-text-scale';

/** 倍率を掛けるpx / remの長さ */
const SCALABLE_LENGTH_PATTERN = /^(?:\d+\.?\d*|\.\d+)(?:px|rem)$/;

/**
 * font-size / line-height の長さを、文字の大きさの倍率を掛けた長さにする
 * React Native形式の数値はpx相当として扱う。
 * em・%・単位の無い行の高さ（'1.25'、'normal'）と、倍率付きにした値はそのまま返すため、何度通しても同じ値になる。
 * @param {number | string} length - 長さ
 * @returns {number | string} 倍率付きの長さ
 */
export const toScaledTextLength = (length: number | string): number | string => {
  if (typeof length === 'number') {
    return Number.isFinite(length) ? `calc(${length}px * var(${TEXT_SCALE_CSS_VARIABLE}, 1))` : length;
  }
  const trimmedLength = length.trim();
  return SCALABLE_LENGTH_PATTERN.test(trimmedLength)
    ? `calc(${trimmedLength} * var(${TEXT_SCALE_CSS_VARIABLE}, 1))`
    : length;
};
